module.exports = __webpack_public_path__ + "static/media/acct_global-functionality.8ef3e8e6.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/acct_global-functionality.md
// module id = 1077
// module chunks = 0